export const SAVE = '@dashboardConfig/SAVE';
export const UPDATE = '@dashboardConfig/UPDATE';
export const REMOVE = '@dashboardConfig/REMOVE';
